<template>
  <div id="main-content">
    <article>
      <div class="entry-content">
        <h2><strong>GlucoTest</strong></h2>
        <div>
          <!-- Liste des onglets -->
          <ul class="et_pb_tabs_controls clearfix">
            <li v-for="(tab, index) in tabs" :key="index" @click="activeTab = index" :class="{'et_pb_tab_active': activeTab === index}">
              <a href="#">{{ tab.name }}</a>
            </li>
          </ul>
          <!-- Contenu des onglets -->
          <div v-for="(tab, index) in tabs" :key="index" v-show="activeTab === index">
            <div v-html="tab.content"></div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'GlucotestI',
  data() {
    return {
      activeTab: 0, // L'onglet actif est initialisé à 0
      tabs: [
        { name: 'Glucotest 75 Orange', content: '<p>chaque bouteille de 200ml contient 75g de glucose</p><img src="@/assets/glucotest.png">' },
        { name: 'Glucotest 50 Orange', content: '<p>chaque bouteille de 200ml contient 75g de glucose</p><img src="@/assets/glucotest.png">' },
        { name: 'Glucotest 75 Citron', content: '<p>chaque bouteille de 200ml contient 75g de glucose</p><img src="@/assets/glucotest.png">' },
        { name: 'Glucotest 50 Citron', content: '<p>chaque bouteille de 200ml contient 75g de glucose</p><img src="@/assets/glucotest.png">' }  // Correction du nom de l'image
      ]
    };
  }
};
</script>

<style scoped>
/* Styles spécifiques aux onglets */
.entry-content{
    padding: 100px;
}
.et_pb_tabs_controls li {
  display: inline-block;
  cursor: pointer;
  padding: 10px;
  background-color: #f4f4f4;
  margin-right: 10px;
  border-radius: 5px;
}

.et_pb_tabs_controls li a {
  text-decoration: none;
  color: #333;
}

.et_pb_tab_active a {
  font-weight: bold;
  color: #000;
}

.et_pb_tabs_controls {
  margin-bottom: 20px;
}

.entry-content img {
  max-width: 100%;
  height: auto;
  margin-top: 10px;
}
</style>
